import cn from 'classnames';
import React, { memo } from 'react';

import type { IConfig } from '@sravni/types/lib/branding';

import { useShowBottomBannerOnScroll } from '@src/hooks/useShowBottomBannerOnScroll';

import styles from './styles.module.scss';

interface IProps {
  className?: string;
  brandingConfig?: IConfig['creditCalculator'];
}

export const HeaderBrandingBanner: React.FC<IProps> = memo(({ children, className }) => {
  const { scrollRef } = useShowBottomBannerOnScroll();

  return (
    <section ref={scrollRef} className={cn(styles.page_header_branding, className)}>
      {children}
    </section>
  );
});
